export function canPreselect({ preselectId, artworks, alreadySelected } = {}) {
  if (!preselectId) return { ok: false, reason: 'no_param' }
  const target = (artworks || []).find((a) => a.id === preselectId)
  if (!target) return { ok: false, reason: 'not_found' }
  if (target.stock === 0) return { ok: false, reason: 'sold_out' }
  if ((alreadySelected || []).includes(preselectId)) {
    return { ok: false, reason: 'already_selected' }
  }
  return { ok: true, target }
}
